import React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import CardSection from '@lightspeed/cirrus-card/Section';
import Card from '@lightspeed/cirrus-card';
import Input from '@lightspeed/cirrus-input';
import Bone from '@lightspeed/cirrus-bone';
import FormField from 'cirrus/FormField';
import Textarea from 'cirrus/Textarea';

import VendorReturnFormCost, { VendorReturnFormCostSkeleton } from './VendorReturnFormCost';

import { FormCardSection, RefNumNotes, CostSummary } from './VendorReturnForm.style';

const VendorReturnForm = ({
  enabledFields,
  vendorReturn,
  isClosed,
  isLoading,
  /* formik */
  errors,
  values,
  setFieldError,
  setFieldValue,
}) => {
  const { refNum, Note: { note } = {} } = values;
  return !isEmpty(values) && !isLoading ? (
    <Card className="cr-mb-3">
      <FormCardSection noSpacing>
        <RefNumNotes>
          <FormField
            label="Reference number"
            status={errors.refNum ? { type: 'error', message: errors.refNum } : {}}
            className="cr-mb-2"
          >
            <Input
              name="refNum"
              value={refNum}
              maxLength="255"
              disabled={!~enabledFields.indexOf('refNum')}
              onChange={event => {
                setFieldValue('refNum', event.target.value);
                setFieldError('refNum');
              }}
              data-test="vendor-return-ref-num-input"
            />
          </FormField>
          <FormField
            label="Notes"
            status={
              get(errors, 'Note.note') ? { type: 'error', message: get(errors, 'Note.note') } : {}
            }
          >
            <Textarea
              name="notes"
              value={note}
              rows={4}
              disabled={!~enabledFields.indexOf('Note.note')}
              onChange={event => {
                setFieldValue('Note.note', event.target.value);
                setFieldError('Note.note');
              }}
              data-test="vendor-return-note-textarea"
            />
          </FormField>
        </RefNumNotes>
        <CostSummary>
          <VendorReturnFormCost
            enabledFields={enabledFields}
            vendorReturn={vendorReturn}
            isClosed={isClosed}
            /* formik */
            values={values}
            setFieldValue={setFieldValue}
          />
        </CostSummary>
      </FormCardSection>
    </Card>
  ) : (
    <VendorReturnFormSkeleton />
  );
};

export const VendorReturnFormSkeleton = () => (
  <Card className="cr-mb-4">
    <CardSection className="cr-flex" noSpacing>
      <RefNumNotes>
        <Bone width="20%" className="cr-mb-1" />
        <Bone className="cr-mb-2" height="1.875rem" />
        <Bone width="20%" className="cr-mb-1" />
        <Bone height="7.5rem" />
      </RefNumNotes>
      <CostSummary>
        <VendorReturnFormCostSkeleton />
      </CostSummary>
    </CardSection>
  </Card>
);

export default VendorReturnForm;
